/// <reference types="crypto-js" />

import * as CryptoJS from 'crypto-js';

export class EncryptionService {

  static key = CryptoJS.enc.Utf8.parse('654198135138894985');
  static iv = CryptoJS.enc.Utf8.parse('6516854984354894845');

  static encrypt(input: string): string {
    return  CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(input), this.key,
    {
        keySize: 128 / 8,
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
  }

  static decrypt(input: string): string {
    return CryptoJS.AES.decrypt(input, this.key, {
      keySize: 128 / 8,
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
  }
}
